import { useSystemConfig } from '../lib/system-config';

/**
 * Returns the auto-refresh interval in milliseconds based on system configuration.
 * Subscribes to the store for reactive updates.
 * Returns 0 if auto-refresh is disabled or set to 0.
 */
export function useAutoRefreshInterval(): number {
    const seconds = useSystemConfig((state) => state.config.defaults.autoRefreshSeconds);

    // Safety check for NaN or negative values, though Settings page handles this.
    // Default to 0 (off) if invalid.
    if (!seconds || seconds <= 0 || isNaN(seconds)) {
        return 0;
    }

    return seconds * 1000;
}
